class Controller {
  constructor($mdDialog, booking) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.booking = booking;
    this.selected = {};
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    const amount = Object.assign({}, { amount: this.selected.amount * 100 });

    this.$mdDialog.hide(amount);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/actionListTable/payDialog/payDialog.controller.js